import { environment } from '../../environments/environment';

export const ERROR_USER_LOCKED = {
  'title': 'Ihr Benutzerkonto ist gesperrt',
  'message': `Um Ihren Benutzer wieder zu entsperren, halten Sie bitte die Pr&uuml;fziffer zur Verifizierung bereit.
    Diese haben Sie nach Registrierung in einer gesonderten E-Mail erhalten.<br/>`,
  'forwardLink': 'resetaccount',
  'forwardText': 'Benutzer zurücksetzen',
};

export const ERROR_USER_DELETED = {
  'title': 'Ihr Benutzer wurde gelöscht',
  'message': `Ihre Pr&uuml;fziffer wurde zu oft falsch eingegeben.<br/>
    Aus Sicherheitsgründen müssen Sie die Registrierung erneut durchführen.`
};

export const ERROR_MAX_QUERIES = {
  'title': 'Abfragekontingent erschöpft',
  'message': `Der Dienst ist für heute ausgeschöpft.<br/><br/>
    Die Funktionalität steht ihnen morgen wieder zur Verfügung.<br/><br/>
    Sie wurden automatisch abgemeldet.`
};

export const ERROR_SERVICE_NOT_AVAILABLE = {
  'title': 'Dienst steht nicht zur Verfügung',
  'message': `Der Abfragedienst steht im Augenblick nicht zur Verfügung<br/><br/>
    Bitte versuchen Sie es später noch einmal!`
};

let aokOhaServiceMailAdress = environment.customizingAok.OhaServiceMail;

export const ERROR_USER_IN_REGISTRATION = {
  'title': 'Registrierung wird bearbeitet',
  'message': `Ihre Registrierung liegt uns vor. Sie bekommen demnächst zwei E-Mails.` + (aokOhaServiceMailAdress.length > 0
      ? `<br/><br/>
        Sollten Sie im laufe der nächsten Stunden keine E-Mail von uns erhalten:<br/>
        Schreiben Sie eine E-Mail mit Ihrem Benutzernamen und dem Betreff "Registrierung pr&uuml;fen" an:<br/><br/>
        ` + aokOhaServiceMailAdress + `<br/><br/>`
      : ``)
};



// WEBPACK FOOTER //
// ./src/app/error/errorMessage.ts